import { DatePicker, DatePickerProps } from '@almbrand/datepicker';
import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import classNames from 'classnames';
import { ThemeNames } from 'constantsValues';
import { PageContext } from 'context/PageContext';
import { useContext, useState } from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { useAppSelector } from 'store/hooks';
import { formatDkDate } from '../../../utilities/format';
import styles from './DatePickerComponent.module.scss';

export interface DatePickerComponentProps extends DatePickerProps<ThemeUnion> {
	register: UseFormRegister<FieldValues>;
	name: string;
	contentType: string;
	submitStep?: () => void;
	stepTitle?: string;
}

export const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
	register,
	name,
	contentType,
	submitStep,
	...props
}) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext ?? {};
	const themeName = ThemeNames[theme];
	const { displayGlobalError } = useAppSelector((state) => state.error);
	const { onChange, name: datePickerComponentName } = register(name, { required: true });
	const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);

	const updatedComponentProps = {
		...props,
		...{ errorMessage: undefined },
		calculateValidRange: true,
	};

	const handleOnChange = (value: Date) => {
		setSelectedDate(value);

		onChange({
			target: {
				name: datePickerComponentName,
				value: {
					id: name,
					value,
					label: formatDkDate(value),
					type: contentType,
					stepTitle: props.stepTitle,
				},
			},
		});
		submitStep?.();
	};

	return (
		<div className={classNames(styles.DatePickerComponent, selectedDate && styles.DatePickerComponent__selected)}>
			<DatePicker
				errorMessage={displayGlobalError ? undefined : props.errorMessage}
				{...updatedComponentProps}
				icon={{ iconProp: { themeName, icon: 'calendar' } }}
				onDateChange={handleOnChange}
				noIconOnError
			/>
		</div>
	);
};
